export default __webpack_public_path__ + "static/media/Reports.01305e94.svg";